import dayjs from 'dayjs';

import {
  ChartTooltipElementProps,
  DataPopperRow,
  Typography,
  tokens,
} from '@cast/design-system';

import { WithEvent } from '../../_types';

type EventTooltipData = { timestamp: string } & WithEvent;

type Props<T extends EventTooltipData> = ChartTooltipElementProps<T> & {
  timezone: string;
  dividerBottom?: boolean;
};

export const EventTooltipHeader = <T extends EventTooltipData>({
  data,
  testId,
  timezone,
  dividerBottom = true,
}: Props<T>) => {
  if (data.event) {
    return (
      <DataPopperRow
        testId={testId}
        dividerBottom={dividerBottom}
        left={
          <Typography variant="L10M">{data.event.displayNameShort}</Typography>
        }
        right={
          <Typography
            variant="L10M"
            color={tokens.theme.fg.structural.secondary}
          >
            {dayjs.utc(data.timestamp).tz(timezone).format('MM/DD h:mm A')}
          </Typography>
        }
      />
    );
  }

  return (
    <DataPopperRow
      testId={testId}
      dividerBottom={dividerBottom}
      left={
        <Typography variant="L10M" color={tokens.theme.fg.structural.secondary}>
          {dayjs(data.timestamp).tz(timezone).format('MMM DD')}
        </Typography>
      }
      right={
        <Typography variant="L10M" color={tokens.theme.fg.structural.secondary}>
          {dayjs(data.timestamp).tz(timezone).format('h:mm A')}
        </Typography>
      }
    />
  );
};
